import Vue from 'vue';
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

Vue.component(FeatherIcon.name, FeatherIcon);
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
